jQuery( document ).ready( function ( $ ) {

	function setMessage( container, message, type ) {
		var messageElement = container.find( '.wplngadmin-download-message' );

		messageElement.removeClass( 'is-error is-success is-loading' );
		messageElement.addClass( type );
		messageElement.text( message );
	}

	function resetResult( container ) {
		container.find( '.wplngadmin-download-result' ).attr( 'hidden', true );
		container.find( '.wplngadmin-download-version' ).text( '' );
		container.find( '.wplngadmin-download-tested' ).text( '' );
		container.find( '.wplngadmin-download-requires' ).text( '' );
		container.find( '.wplngadmin-download-link' ).attr( 'href', '#' );
	}

	$( '[data-wplngadmin-download]' ).each( function () {
		var container = $( this );
		var input = container.find( '.wplngadmin-download-input' );
		var button = container.find( '.wplngadmin-download-button' );

		if ( ! input.length || ! button.length ) {
			return;
		}

		button.on( 'click', function () {
			var apiKey = input.val().trim();

			if ( apiKey !== input.val() ) {
				input.val( apiKey );
			}

			resetResult( container );

			if ( apiKey.length === 0 ) {
				setMessage( container, wplngadminDownloadLocalize.msgEmptyKey, 'is-error' );
				return;
			}

			button.prop( 'disabled', true );
			setMessage( container, wplngadminDownloadLocalize.msgChecking, 'is-loading' );

			$.ajax( {
				url: wplngadminDownloadLocalize.ajaxUrl,
				method: 'POST',
				data: {
					action: 'wplngadmin_ajax_download_info',
					nonce: wplngadminDownloadLocalize.nonce,
					wplingua_key: apiKey
				}
			} ).done( function ( response ) {
				if ( ! response || ! response.success || ! response.data ) {
					setMessage( container, wplngadminDownloadLocalize.msgUnableFetch, 'is-error' );
					return;
				}

				if ( ! response.data.package ) {
					setMessage( container, wplngadminDownloadLocalize.msgNoDownloadLink, 'is-error' );
					return;
				}

				container.find( '.wplngadmin-download-version' ).text( response.data.new_version || '-' );
				container.find( '.wplngadmin-download-tested' ).text( response.data.tested || '-' );
				container.find( '.wplngadmin-download-requires' ).text( response.data.requires || '-' );
				container.find( '.wplngadmin-download-link' ).attr( 'href', response.data.package );
				container.find( '.wplngadmin-download-result' ).removeAttr( 'hidden' );

				setMessage( container, wplngadminDownloadLocalize.msgSuccess, 'is-success' );
			} ).fail( function () {
				setMessage( container, wplngadminDownloadLocalize.msgNetworkError, 'is-error' );
			} ).always( function () {
				button.prop( 'disabled', false );
			} );
		} );
	} );

} );
